import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false

function getCookie(name) {
  const cookieName = encodeURIComponent(name) + "=";
  const cookieStart = document.cookie.indexOf(cookieName);
  let cookieValue = null;
  if (cookieStart > -1){
      //stringObject.indexOf(searchvalue,fromindex)
      let cookieEnd = document.cookie.indexOf(";",cookieStart);
      if (cookieEnd == -1){//如果不存在，则只有一个cookie
          cookieEnd = document.cookie.length;
      }
      cookieValue = decodeURIComponent(document.cookie.substring(cookieStart+cookieName.length,cookieEnd));
  }
  return cookieValue;
}

axios.get('/toolbox/getUsername').then(({data}) => {
  Vue.prototype.$userid = data;
})

// Vue.prototype.$userid = getCookie('userid');
// Vue.prototype.$username = getCookie('username');

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')